import apiClient from "@/lib/apiClient";
import type {
  ClientAnnouncementsListParams,
  ClientAnnouncementDetailItem,
} from "../types/client-announcements.types";

const BASE = "/api/client/announcements";

/**
 * GET /api/client/announcements/categories
 * Get categories for filter (departments and educations with announcements)
 * Response: { status, data: { success, status, data: { items }, message } }
 */
export async function getCategories() {
  const { data } = await apiClient.get(`${BASE}/categories`);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const raw = data as any;
  return raw?.data?.data?.items ?? raw?.data?.items ?? raw?.items ?? [];
}

/**
 * GET /api/client/announcements
 * List announcements for current user (Genel, Özel or all).
 * Response: { status, data: { success, status, data: [], message, count } }
 */
export async function getAnnouncements(params?: ClientAnnouncementsListParams) {
  const { data } = await apiClient.get(BASE, {
    params: {
      type: params?.type ?? "all",
      search: params?.search,
      dateFrom: params?.dateFrom,
      dateTo: params?.dateTo,
      sortBy: params?.sortBy ?? "startDate",
      sortOrder: params?.sortOrder ?? "desc",
      page: params?.page ?? 1,
      limit: params?.limit ?? 12,
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const raw = data as any;
  const inner = raw?.data;
  return {
    items: inner?.data ?? raw?.data ?? [],
    total: inner?.count ?? raw?.count ?? 0,
  };
}

/**
 * GET /api/client/announcements/{id}
 * Get announcement detail by ID
 */
/**
 * GET /api/client/announcements/{id}
 * Get announcement detail by ID.
 * Response shape may be { status, data: { success, status, data: detail, message } } or { data: detail }.
 */
export async function getAnnouncementById(id: string) {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  const inner = (data as { data?: { data?: ClientAnnouncementDetailItem } })
    .data;
  const detail =
    inner && typeof inner === "object" && "data" in inner
      ? (inner as { data: ClientAnnouncementDetailItem }).data
      : (data as { data: ClientAnnouncementDetailItem }).data;
  return detail;
}

export const clientAnnouncementsApi = {
  getCategories,
  getAnnouncements,
  getAnnouncementById,
};
